import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StudyLandingComponent } from './__PAGES/__LANDINGS/study-landing/study-landing.component';
import { HeaderComponent } from './__SECTIONS/__common/header/header.component';
import { TestimonialAComponent } from './testimonial-a/testimonial-a.component';
import { WorkLandingComponent } from './__PAGES/__LANDINGS/work-landing/work-landing.component';
import { SectionTwoColComponent } from './__SECTIONS/section-two-col/section-two-col.component';
import { SectionFullScreenVideoComponent } from './__SECTIONS/section-full-screen-video/section-full-screen-video.component';
import { TestimonialCarouselComponent } from './testimonial-carousel/testimonial-carousel.component';
import { CardTestimonialComponent } from './card-testimonial/card-testimonial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// MATERIAL
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';


import { PageTitleComponent } from './page-title/page-title.component';
import { FooterComponent } from './__SECTIONS/__common/footer/footer.component';
import { FooterLandingComponent } from './__SECTIONS/__common/footer-landing/footer-landing.component';
import { AccommodationLandingComponent } from './__PAGES/__LANDINGS/accommodation-landing/accommodation-landing.component';
import { FullScreenBannerAComponent } from './full-screen-banner-a/full-screen-banner-a.component';
import { ExtranjeriaLandingComponent } from './__PAGES/__LANDINGS/extranjeria-landing/extranjeria-landing.component';
import { InsuranceLandingComponent } from './__PAGES/__LANDINGS/insurance-landing/insurance-landing.component';
import { WebappBannerComponent } from './__SECTIONS/webapp-banner/webapp-banner.component';
import { ProductOfferComponent } from './__SECTIONS/product-offer/product-offer.component';
import { VisadoLandingComponent } from './__PAGES/__LANDINGS/visado-landing/visado-landing.component';

@NgModule({
  declarations: [
    AppComponent,
    StudyLandingComponent,
    HeaderComponent,
    TestimonialAComponent,
    WorkLandingComponent,
    SectionTwoColComponent,
    SectionFullScreenVideoComponent,
    TestimonialCarouselComponent,
    CardTestimonialComponent,
    PageTitleComponent,
    FooterComponent,
    FooterLandingComponent,
    AccommodationLandingComponent,
    FullScreenBannerAComponent,
    ExtranjeriaLandingComponent,
    InsuranceLandingComponent,
    WebappBannerComponent,
    ProductOfferComponent,
    VisadoLandingComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
     // MATERIAL
    MatCardModule,
    // Menú
    MatMenuModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
